import { forwardRef } from "react";
import classnames from "classnames";
import Button from "../buttons/button/Button";
import styles from "./GalleryActionButton.scss";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { TEXT_SIZES } from "../../constants";

interface GalleryActionButtonProps {
  iconClass?: string;
  ariaLabel: string;
  buttonText: string;
  handleClick: React.MouseEventHandler<HTMLButtonElement>;
  dataTestId?: string;
  className?: string;
}

const GalleryActionButton = forwardRef<
  HTMLButtonElement,
  GalleryActionButtonProps
>(
  (
    { iconClass, ariaLabel, buttonText, handleClick, dataTestId, className },
    ref,
  ) => {
    return (
      <Button
        handleClick={handleClick}
        ariaLabel={ariaLabel}
        size={TEXT_SIZES.london3}
        type={BUTTON_TYPES.naked}
        dataTestId={dataTestId}
        buttonRef={ref}
        additionalClasses={classnames(styles.galleryActionButton, className)}
      >
        {iconClass && (
          <span className={iconClass} data-testid="galleryButtonIcon" />
        )}
        <span>{buttonText}</span>
      </Button>
    );
  },
);

GalleryActionButton.displayName = "GalleryActionButton";

export default GalleryActionButton;
